import {LotoCardboard} from "../../domain/entities/LotoCardboard";
import {NewLotoCardboardPayload, LotoCardboardRepository} from "../ports/LotoCardboardRepository";
import {validateLotoCardboardNumbers} from "../../domain/services/LotoCardboardValidator";

export class AddLotoCardboard {
    constructor(private readonly repo: LotoCardboardRepository) {}

    async execute(payload: NewLotoCardboardPayload): Promise<LotoCardboard> {
        const validation = validateLotoCardboardNumbers(payload.numbers);
        if (!validation.valid) throw new Error(validation.errors.join(" • "));
        return this.repo.add(payload);
    }
}
